(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function initHeader() {
    const header = $('[data-site-header]');
    if (!header) return;

    const menuButton = $('[data-menu-toggle]', header);
    const mobileNav = $('[data-mobile-nav]', header);
    if (menuButton && mobileNav) {
      menuButton.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('is-open');
        menuButton.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('pp-nav-open', open);
      });
    }

    const navItems = $$('[data-nav-item]', header);
    const closeAll = (except = null) => {
      navItems.forEach(item => {
        if (item === except) return;
        item.classList.remove('is-open');
        const trigger = $('[data-nav-trigger]', item);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    navItems.forEach(item => {
      const trigger = $('[data-nav-trigger]', item);
      if (!trigger) return;

      trigger.addEventListener('click', event => {
        // A parent menu configured as # should act as a menu control, not navigate.
        if (trigger.tagName === 'BUTTON' || trigger.getAttribute('href') === '#') event.preventDefault();
        const willOpen = !item.classList.contains('is-open');
        closeAll(item);
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', String(willOpen));
      });

      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', event => {
      if (!event.target.closest('[data-nav-item]')) closeAll();
    });
  }

  const colorAliases = {
    'white': ['white','whi'],
    'black': ['black','blk'],
    'red': ['red'],
    'navy': ['navy'],
    'blue': ['blue','blu'],
    'royal-blue': ['royal','royalblue','blue'],
    'burgundy': ['burgundy','burg','wine','maroon'],
    'forest-green': ['forestgreen','forest','green'],
    'green': ['green'],
    'gray': ['gray','grey'],
    'grey': ['gray','grey'],
    'tan': ['tan','sand'],
    'beige': ['beige','cream','sand'],
    'cream': ['cream','beige'],
    'orange': ['orange']
  };

  const normalize = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

  function initProduct(root) {
    const jsonNode = $('[data-product-variants]', root.parentElement || document) || $('[data-product-variants]');
    if (!jsonNode) return;

    let variants;
    try { variants = JSON.parse(jsonNode.textContent); } catch (e) { return; }

    const selects = $$('[data-option-index]', root);
    const variantInput = $('[data-variant-id]', root);
    const addButton = $('[data-add-to-cart]', root);
    const addText = $('[data-add-to-cart-text]', root);
    const price = $('[data-product-price]', root);
    const compare = $('[data-compare-price]', root);
    const stock = $('[data-stock-line]', root);
    const quantity = $('[data-quantity-input]', root);
    const thumbs = $$('[data-media-thumb]', root);
    const mainImage = $('[data-main-media]', root);
    const form = $('.pp-ajax-product-form', root);
    const message = $('[data-product-form-message]', root);

    function optionIsAvailable(index, value, selectedValues) {
      return variants.some(variant => {
        if (!variant.available || variant.options[index] !== value) return false;
        // Linked-options behavior: an option depends on choices before it, not after it.
        for (let previous = 0; previous < index; previous += 1) {
          if (variant.options[previous] !== selectedValues[previous]) return false;
        }
        return true;
      });
    }

    function refreshOptions() {
      const selected = selects.map(select => select.value);
      selects.forEach((select, index) => {
        let firstAvailable = null;
        Array.from(select.options).forEach(option => {
          const available = optionIsAvailable(index, option.value, selected);
          option.disabled = !available;
          const base = option.dataset.originalLabel || option.value;
          option.textContent = available ? base : `${base} — Sold out`;
          if (available && !firstAvailable) firstAvailable = option;
        });
        if (select.selectedOptions[0] && select.selectedOptions[0].disabled && firstAvailable) {
          select.value = firstAvailable.value;
        }
        selected[index] = select.value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(variant => variant.options.every((value, index) => value === selected[index]));
    }

    function setMainMediaFromThumb(thumb) {
      if (!thumb || !mainImage) return;
      mainImage.src = thumb.dataset.mediaSrc;
      mainImage.alt = thumb.dataset.mediaAlt || mainImage.alt;
      mainImage.dataset.zoomSrc = thumb.dataset.mediaZoomSrc || thumb.dataset.mediaSrc;
      thumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
      const zoomImage = $('[data-zoom-image]', root.parentElement || document);
      if (zoomImage) {
        zoomImage.src = thumb.dataset.mediaZoomSrc || thumb.dataset.mediaSrc;
        zoomImage.alt = thumb.dataset.mediaAlt || mainImage.alt;
      }
    }

    function findColorThumb(colorValue) {
      if (!colorValue) return null;
      const key = String(colorValue).toLowerCase().trim().replace(/\s+/g, '-');
      const aliases = colorAliases[key] || [normalize(colorValue)];
      return thumbs.find(thumb => {
        const haystack = normalize(`${thumb.dataset.mediaAlt || ''} ${thumb.dataset.mediaSrc || ''}`);
        return aliases.some(alias => haystack.includes(normalize(alias)));
      }) || null;
    }

    function updateMedia(variant) {
      if (!thumbs.length || !mainImage) return;
      let thumb = variant && variant.featured_media_id ? thumbs.find(t => String(t.dataset.mediaId) === String(variant.featured_media_id)) : null;
      if (!thumb) {
        const colorSelect = selects.find(select => normalize(select.dataset.optionName).includes('color') || normalize(select.dataset.optionName).includes('colour'));
        if (colorSelect) thumb = findColorThumb(colorSelect.value);
      }
      if (thumb) setMainMediaFromThumb(thumb);
    }

    function updateVariant() {
      const selected = refreshOptions();
      const variant = findVariant(selected);

      if (!variant) {
        if (variantInput) variantInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        if (stock) stock.innerHTML = '<span class="pp-stock-dot is-out"></span> Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = variant.price_formatted;
      if (compare) {
        const showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !showCompare;
        compare.textContent = showCompare ? variant.compare_at_price_formatted : '';
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      if (stock) stock.innerHTML = variant.available ? '<span class="pp-stock-dot"></span> In stock' : '<span class="pp-stock-dot is-out"></span> Sold out';

      if (quantity) {
        quantity.min = 1;
        if (variant.inventory_management && variant.inventory_policy === 'deny' && variant.inventory_quantity > 0) {
          quantity.max = variant.inventory_quantity;
          if (Number(quantity.value) > variant.inventory_quantity) quantity.value = variant.inventory_quantity;
        } else {
          quantity.removeAttribute('max');
        }
      }

      updateMedia(variant);
      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(select => select.addEventListener('change', updateVariant));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => setMainMediaFromThumb(thumb)));

    const zoomTrigger = $('[data-zoom-trigger]', root);
    const zoomDialog = $('[data-zoom-dialog]', root.parentElement || document);
    const zoomClose = $('[data-zoom-close]', root.parentElement || document);
    if (zoomTrigger && zoomDialog) {
      zoomTrigger.addEventListener('click', () => {
        const zoomImage = $('[data-zoom-image]', zoomDialog);
        if (zoomImage && mainImage) {
          zoomImage.src = mainImage.dataset.zoomSrc || mainImage.src;
          zoomImage.alt = mainImage.alt;
        }
        if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
      });
      if (zoomClose) zoomClose.addEventListener('click', () => zoomDialog.close());
      zoomDialog.addEventListener('click', event => { if (event.target === zoomDialog) zoomDialog.close(); });
    }

    if (form) initAjaxProductForm(form, message, addText);
    updateVariant();
  }

  async function refreshCartCount() {
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count > 0 ? `(${cart.item_count})` : ''; });
    } catch (_) {}
  }

  function showToast(text) {
    const toast = $('[data-theme-toast]');
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  function initAjaxProductForm(form, message = null, buttonTextNode = null) {
    if (form.dataset.ajaxReady === 'true') return;
    form.dataset.ajaxReady = 'true';
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = $('button[type="submit"]', form);
      if (button && button.disabled) return;
      const originalText = buttonTextNode ? buttonTextNode.textContent : (button ? button.textContent : '');
      if (button) button.disabled = true;
      if (buttonTextNode) buttonTextNode.textContent = 'Adding…';
      else if (button) button.textContent = 'Adding…';
      if (message) { message.hidden = true; message.textContent = ''; }

      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'This item could not be added to your bag.');
        await refreshCartCount();
        showToast('Added to your bag.');
        if (buttonTextNode) buttonTextNode.textContent = 'Added to Bag';
        else if (button) button.textContent = 'Added to Bag';
        setTimeout(() => {
          if (buttonTextNode) buttonTextNode.textContent = originalText || 'Add to Bag';
          else if (button) button.textContent = originalText || 'Add to Bag';
          if (button) button.disabled = false;
        }, 1500);
      } catch (error) {
        if (message) { message.hidden = false; message.textContent = error.message; }
        showToast(error.message);
        if (buttonTextNode) buttonTextNode.textContent = originalText || 'Add to Bag';
        else if (button) button.textContent = originalText || 'Add to Bag';
        if (button) button.disabled = false;
      }
    });
  }

  function initProductCardForms() {
    $$('form.pp-ajax-product-form').forEach(form => {
      if (form.closest('[data-product-root]')) return;
      initAjaxProductForm(form);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    initHeader();
    $$('[data-product-root]').forEach(initProduct);
    initProductCardForms();
  });
})();
